/**
 * @Description 机会点详情-核心信息模块-基诺浦测算信息
 */

import { FC, useMemo } from 'react';
import { CoreInfoConfig } from '@/common/components/business/DynamicComponent/components/CalculationJNP/ts-config';
import TableDetail from '@/common/components/business/DynamicComponent/components/CalculationJNP/components/TableDetail';
import styles from '../index.module.less';
import { replaceEmpty } from '@lhb/func';

interface JNPInfoProps {
  allFields?: any[];
  jnpObject?: any;
}

const fieldsList = [
  'collaborationMode',
  'applicationNature',
  'channelType',
  'expectedOpeningTime',
  'basicUsableArea',
  'actualarea',
  'externalFacadeArea',
  'employeeStaffing',
];

const JNPInfo: FC<JNPInfoProps> = ({ jnpObject, allFields }) => {

  const jnpInfoDetail = useMemo(() => {
    const obj:any = {};
    allFields?.forEach((item) => {
      if (fieldsList?.includes(item.identification)) {
        try {
          obj[item.identification] = JSON.parse(item.textValue);
        } catch (error) {
          obj[item.identification] = item.textValue;
        }
      }
    });
    return obj;
  }, [allFields]);

  return <>
    <div className={styles.jnpInfoDetail}>
      { [
        { label: '合作模式', value: jnpInfoDetail.collaborationMode?.name },
        { label: '申请性质', value: jnpInfoDetail.applicationNature?.name },
        { label: '渠道类型', value: jnpInfoDetail.channelType?.name },
        { label: '预计开业时间', value: jnpInfoDetail.expectedOpeningTime },
        { label: '提报合同面积', value: `${replaceEmpty(jnpInfoDetail.basicUsableArea?.value)}${jnpInfoDetail.basicUsableArea?.suffix || ''}` },
        { label: '外立面面积', value: `${replaceEmpty(jnpInfoDetail.actualarea?.value)}${jnpInfoDetail.actualarea?.suffix || ''}` },
        { label: '规划实用面积(包仓库）', value: `${replaceEmpty(jnpInfoDetail.externalFacadeArea?.value)}${jnpInfoDetail.externalFacadeArea?.suffix || ''}` },
        { label: '员工编制数量(包店长)', value: `${replaceEmpty(jnpInfoDetail.employeeStaffing?.value)}${jnpInfoDetail.employeeStaffing?.suffix || ''}` },
      ].map((item) => <div key={item.label} className={styles.jnpInfoDetailItem}>
        <div className={styles.jnpInfoDetailItemLabel}>{item.label}</div>
        <div className={styles.jnpInfoDetailItemValue}>{replaceEmpty(item.value)}</div>
      </div>)}

    </div>
    <TableDetail
      moduleConfig={CoreInfoConfig}
      jnpObject={jnpObject}
    />
  </>;
};

export default JNPInfo;
